import React from "react";
import { useParams } from "react-router";
import { avatarAtomFamily } from "../../jotai/atoms";
import { setRecordAvatar } from "../../jotai/atomUpdater";
import { useAtom } from "jotai";
import { avatars } from "../../utils/data";
import { NotFound } from "../../components/NotFound";
import { Link } from "react-router-dom";

export default function AvatarList() {
  const { id } = useParams();
  const [currAvatarId] = useAtom(avatarAtomFamily(id ?? ""));

  if (!id) {
    return <NotFound />;
  }

  const selectAvatar = async (avatarId: number) => {
    const updateValue = currAvatarId === avatarId ? null : avatarId;
    await setRecordAvatar(id, updateValue);
  };

  return (
    <div className="flex flex-col gap-1 max-md:pb-20 max-md:mt-5">
      <div className="md:pb-8 max-md:hidden w-fit mr-auto">
        <Link to="/home/records" className="docket-link">
          <img src="/assets/images/chevron-left-solid.svg" className="h-6" />
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-1 px-6 max-md:pb-20">
        {Array.from(avatars.entries()).map(([avatarId, src]) => (
          <>
            <div
              className="p-4 mx-auto cursor-pointer rounded-full md:hidden"
              onClick={() => selectAvatar(avatarId)}
              style={{
                backgroundColor: currAvatarId === avatarId ? "white" : "",
              }}
            >
              <img className="w-[60px]" src={src} />
            </div>
            <div
              className="p-4 mx-auto cursor-pointer rounded-full max-md:hidden"
              onClick={() => selectAvatar(avatarId)}
              style={{
                backgroundColor: currAvatarId === avatarId ? "gray" : "",
              }}
            >
              <img className="w-[60px]" src={src} />
            </div>
          </>
        ))}
      </div>
    </div>
  );
}
